import { DescriptionList, Flex, Tag } from '@applyboard/crystal-ui'

import { ApplicationDetailsStatus } from '../types'

import { ApplicationDetailCardDescriptionItem } from './ApplicationDetailCardDescriptionItem'
import { getTagInformation } from './utils'
import { format } from 'date-fns'

type ApplicationDetailCardDescriptionProps = Readonly<{
  status: ApplicationDetailsStatus | string
  activeRecord?: boolean
  statusChangedOn?: Date
}>

export function ApplicationDetailCardDescription(props: ApplicationDetailCardDescriptionProps) {
  const { label, intent } = getTagInformation(props.status, props.activeRecord)

  return (
    <DescriptionList variant="free">
      <Flex
        direction={{ xs: 'column', lg: 'row' }}
        gap={4}
        justify={{ xs: 'start', lg: 'between' }}
      >
        <ApplicationDetailCardDescriptionItem
          term="Offer Status"
          details={<Tag intent={intent}>{label}</Tag>}
          activeRecord={props.activeRecord}
        />
        {props.statusChangedOn && (props.status === 'ACCEPTED' || props.status === 'REJECTED') ? (
          <ApplicationDetailCardDescriptionItem
            term={props.status === 'ACCEPTED' ? 'Accepted on' : 'Rejected on'}
            details={<Tag intent="secondary">{format(props.statusChangedOn, 'MMM dd, yyy')}</Tag>}
          />
        ) : null}
      </Flex>
    </DescriptionList>
  )
}
